"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Modal = _interopRequireDefault(require("@cimpress/react-components/lib/Modal"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var formats = _interopRequireWildcard(require("../formats"));

var utils = _interopRequireWildcard(require("../utils"));

var _DownloadModalFooter = _interopRequireDefault(require("./DownloadModalFooter"));

var _FileNameInput = _interopRequireDefault(require("./FileNameInput"));

var _FileTypeInput = _interopRequireDefault(require("./FileTypeInput"));

var DownloadModal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DownloadModal, _PureComponent);

  function DownloadModal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DownloadModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DownloadModal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      fileName: _this.props.initialFileName,
      fileType: _this.props.initialFileType
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeFileName", function (fileName) {
      _this.setState({
        fileName: fileName
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeFileType", function (fileType) {
      _this.setState({
        fileType: fileType
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCancel", function () {
      var onCancel = _this.props.onCancel;
      onCancel && onCancel();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSubmit", function () {
      var _this$props = _this.props,
          columns = _this$props.columns,
          rows = _this$props.rows,
          onSubmit = _this$props.onSubmit;
      var _this$state = _this.state,
          fileName = _this$state.fileName,
          fileType = _this$state.fileType;
      var body = utils.getFileFromDatasheet(rows, columns, fileType);
      var name = utils.getFileName(fileName, fileType);
      onSubmit && onSubmit(body, name);
    });
    return _this;
  }

  (0, _createClass2.default)(DownloadModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          initialFileName = _this$props2.initialFileName,
          initialFileType = _this$props2.initialFileType,
          show = _this$props2.show;

      if (!show && prevProps.show) {
        this.setState({
          fileName: initialFileName,
          fileType: initialFileType
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          show = _this$props3.show,
          onCancel = _this$props3.onCancel;
      var _this$state2 = this.state,
          fileName = _this$state2.fileName,
          fileType = _this$state2.fileType;

      var footer = _react.default.createElement(_DownloadModalFooter.default, {
        canSubmit: !!fileName,
        onCancel: onCancel,
        onSubmit: this.onSubmit
      });

      return _react.default.createElement(_Modal.default, {
        closeButton: true,
        closeOnOutsideClick: true,
        footer: footer,
        show: show,
        title: "Download",
        onRequestHide: onCancel
      }, _react.default.createElement(_FileNameInput.default, {
        value: fileName,
        onChange: this.onChangeFileName
      }), _react.default.createElement(_FileTypeInput.default, {
        value: fileType,
        onChange: this.onChangeFileType
      }));
    }
  }]);
  return DownloadModal;
}(_react.PureComponent);

exports.default = DownloadModal;
(0, _defineProperty2.default)(DownloadModal, "propTypes", {
  columns: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  initialFileName: _propTypes.default.string,
  initialFileType: _propTypes.default.string,
  rows: _propTypes.default.arrayOf(_propTypes.default.objectOf(_propTypes.default.any)).isRequired,
  show: _propTypes.default.bool,
  onCancel: _propTypes.default.func,
  onSubmit: _propTypes.default.func
});
(0, _defineProperty2.default)(DownloadModal, "defaultProps", {
  initialFileName: '',
  initialFileType: formats.XLSX_FORMAT,
  show: false
});